/**
 * 用量概览 Hook：拉取概览数据并同步写入 userStore。
 *
 * @module hooks/useUsageOverview
 */
import { useEffect } from 'react';
import type { UsageOverview } from '@/types';
import { useUserStore } from '@/store/userStore';
import { getOverview } from '@/services/usage';
import { useApi, type UseApiResult } from './useApi';

/**
 * 用量概览 Hook。
 *
 * 请求 `/api/usage/overview` 并将结果写入 userStore，供 Dashboard 等页面复用。
 *
 * @returns 通用请求状态（data 为 UsageOverview）。
 */
export function useUsageOverview(): UseApiResult<UsageOverview> {
  const result = useApi<UsageOverview>(() => getOverview());
  const setUsageOverview = useUserStore((s) => s.setUsageOverview);

  useEffect(() => {
    if (result.data) {
      setUsageOverview(result.data);
    }
  }, [result.data, setUsageOverview]);

  return result;
}
